export const paginatorRowGenerator = (totalCount) => {
  const rowLength = Math.ceil(totalCount / 5);
  const rowArray = [];
  for (let i = 1; i <= rowLength; i++) {
    rowArray.push(i * 5);
  }
  return rowArray;
};
